// extracted by mini-css-extract-plugin
module.exports = {"content":"TermsAndConditionsModal_content__RThgb","categoriesContent":"TermsAndConditionsModal_categoriesContent__7myqA"};